import React from 'react';
import { Link } from 'gatsby';
import { CloseIcon } from './menu-icon';

const MenuModal = ({ links, handleClick }) => {
  return (
    <>
      <div
        className="fixed top-0 left-0 right-0 h-screen w-screen bg-gray-900 overflow-y-auto"
        style={{ zIndex: 999 }}
      >
        <ul className="text-right">
          <li className="lg:border-0 block border-gray-700 py-6 pl-3 pr-10 text-3xl font-light text-white lg:p-0">
            <button
              onClick={handleClick}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleClick();
                }
              }}
              className="flex justify-end pt-6 w-full hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 rounded-sm"
              aria-label="Close menu"
            >
              <CloseIcon color="#ffffff" size="20px" />
            </button>
          </li>
          <li className="lg:border-0 block border-gray-700 py-6 pl-3 pr-10 text-3xl font-light text-white hover:bg-gray-700 hover:text-white lg:p-0 lg:hover:bg-transparent lg:hover:text-white">
            <Link to="/" className="text-white">
              Home
            </Link>
          </li>
          {links.map((link) => (
            <li
              key={link.url}
              className="lg:border-0 block border-gray-700 py-6 pl-3 pr-10 text-3xl font-light text-white hover:bg-gray-700 hover:text-white lg:p-0 lg:hover:bg-transparent lg:hover:text-white"
            >
              <Link to={link.url} className="text-white">
                {link.name}
              </Link>
              {link.dropdown && (
                <ul className="mt-2 pl-6 border-l border-gray-700">
                  {link.dropdown.map((dropdownLink) => (
                    <li
                      key={dropdownLink.url}
                      className="py-3 text-xl font-light text-gray-400 hover:text-white relative"
                    >
                      <span className="absolute -left-6 top-1/2 w-4 h-px bg-gray-700"></span>
                      <Link
                        to={dropdownLink.url}
                        className="text-inherit hover:pl-2 transition-all duration-200"
                      >
                        {dropdownLink.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
          <li className="lg:border-0 block border-gray-700 py-6 pl-3 pr-10 text-3xl font-light text-white hover:bg-gray-700 hover:text-white lg:p-0 lg:hover:bg-transparent lg:hover:text-white">
            <Link
              to="/get-quote"
              className="transform rounded-sm border-2 border-white bg-transparent px-4 py-2 text-center text-2xl font-bold text-white shadow transition-transform hover:scale-105 hover:border-transparent hover:bg-white hover:text-gray-900 hover:shadow-lg md:inline-flex"
            >
              Get Your Free Estimate
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default MenuModal;
